<template>
    <div id='top-menu'>
        <div class='container'>
            <b-navbar toggleable="lg" type="light" >
            <b-navbar-brand href="#"><img class='logo' @click="reload" src='/images/logo.png'></b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="http://runawayrascals.com/how-this-works/">How does this work?</b-nav-item>
                <b-nav-item href="http://www.runawayrascals.com">Blog</b-nav-item>
                <b-nav-item href="http://www.runawayrascals.com/about/">About Us</b-nav-item>
                <b-nav-item href="mailto: us@runawayrascals.com">Contact Us</b-nav-item>
                <b-nav-item href="https://runawayrascals.typeform.com/to/vSW0Ix">Feedback</b-nav-item>
            </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'top-menu',
    components: {

    },

    methods: {
        reload() {
            window.location.reload()
        }
    }
}
</script>

<style scoped lang="scss">
    #top-menu {border-bottom: 1px solid #e4e4e4 !important; background-color: white; z-index: 1}
    img.logo {height: 40px}
    .navbar {
        padding: 1.2rem 0;
        .nav-item a {font-size: 16px; color: #333; font-weight: bold; letter-spacing: -.2px}

        .navbar-toggler {border: none}
    }

</style>